// import React, { ReactNode, useRef } from "react";
import React, {
  forwardRef,
  useRef,
  useImperativeHandle,
  ReactNode,
} from "react";
interface CustomComponentProps {
  className?: string;
  children?: ReactNode;
}

const CustomScroller = forwardRef<HTMLDivElement, CustomComponentProps>(
  ({ children, className }, ref) => {
    return (
      <div ref={ref} className={`flex overflow-x-scroll ${className}`}>
        {children}
      </div>
    );
  }
);

export default CustomScroller;
